import { BellIcon } from '@orn/shared-web/icons';

/**
 * What the Alerts Center shows a household with nothing outstanding — including
 * one whose history is empty too, which is the state a new family starts in.
 * Deliberately not an error tone: no alerts is the good outcome.
 */
const AlertsCenterEmptyState = () => (
  <div className="flex flex-col items-center justify-center px-6 py-16 text-center">
    <div className="bg-utility-mist-400 mb-4 flex size-14 items-center justify-center rounded-full">
      <BellIcon aria-hidden="true" className="text-fg-quaternary size-6" />
    </div>
    <div className="text-primary text-lg font-medium">You’re all caught up</div>
    <div className="text-tertiary mt-1 max-w-xs text-sm">New alerts about your family’s money will show up here.</div>
  </div>
);

export default AlertsCenterEmptyState;
